import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getCurrentUser, signOut as authSignOut, type User } from '../lib/auth-client'

const AUTH_QUERY_KEY = ['currentUser'] as const

export function useAuth() {
  const queryClient = useQueryClient()

  const {
    data: user,
    isLoading,
    error,
    refetch
  } = useQuery<User | null>({
    queryKey: AUTH_QUERY_KEY,
    queryFn: getCurrentUser,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false,
  })

  const signOut = async () => {
    await authSignOut()
    queryClient.setQueryData(AUTH_QUERY_KEY, null)
  }

  const invalidateAuth = () => {
    queryClient.invalidateQueries({ queryKey: AUTH_QUERY_KEY })
  }

  return {
    user: user ?? null,
    isLoading,
    isAuthenticated: !!user,
    error,
    signOut,
    invalidateAuth,
    refetch
  }
}
